import { useAuth } from 'hooks/auth'
import { Navigate, Route, Routes } from 'react-router-dom'
import { LoginPage } from './pages/login/Login'

export default function AuthRoutes() {
    const { isAuthenticated } = useAuth()

    if (isAuthenticated) {
        return <Navigate to="/" />
    }

    return (
        <Routes>
            <Route path="sign-in" element={<LoginPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    )
}
